import styled from 'styled-components';
import { PAGE_CONTAINER } from '../../../../../styles/Layout';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../../../styles/constants';
import { propSwitch } from '../../../../../util/propSwitch';

export const ButtonBarWrapper = styled.div`
  border-bottom: 1px solid ${ThemeColours.mono200};
  margin-bottom: 0;
`;

export const ButtonBarView = styled.div`
  ${PAGE_CONTAINER};
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

export const TabIcon = styled.div`
  height: 16px;
  margin-inline-end: 4px;
  width: 16px;
`;

export const Tab = styled.button<{ selected?: boolean }>`
  ${FONT_STACK};
  align-items: center;
  background: none;
  border: none;
  border-bottom-color: ${propSwitch('selected', ThemeColours.primary, ThemeColours.white)};
  border-bottom-style: solid;
  border-bottom-width: 4px;
  color: ${propSwitch('selected', ThemeColours.primary, ThemeColours.mono600)};
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: auto;
  margin-bottom: 0;
  margin-inline-end: 8px;
  padding: 0 16px 12px;

  &:hover {
    color: ${ThemeColours.primary};
  }

  &:focus {
    outline: none;
  }
`;
